/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { ref, listAll, getDownloadURL, getMetadata, StorageReference, deleteObject } from 'firebase/storage';
import { Card } from 'react-bootstrap';
import Swal from 'sweetalert2';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { storage } from '../../firebase/firebaseConfig';
import { IsLoading } from '../ui/IsLoading';
import { UserContext } from '../../context/UserContext';
import { useKW2P } from '../../hooks';
import format from '../../helpers/format';

interface Params {
    id: number;
    canDelete?: boolean;
    scope: 'adopcion' | 'rehabilitacion';
    medias?: string[];
};

export const MascotaGalery = ({ id, canDelete = false, medias= [] }: Params) => {

    const { languaje } = useContext(UserContext);

    const [loading, setLoading] = useState(false);
    const [gallery, setGallery] = useState < GalleryItem[] > ([]);
    const {mediaObtener} = useKW2P()

    const modalImageRef = useRef < any > ();
    const modalRef = useRef < any > ();


    const getGalery = async () => {

        setLoading(true);
        setGallery([]);

        const storageRef = ref(storage, `mascotas/${id}/`);
        // new Promise((resolve, reject) => {
            await listAll(storageRef)
                .then(async(res) => {
                    
                    setLoading(false);
                    // res.items.forEach(async (itemRef) => {
                    //     const file = await buildItem(itemRef);
                    //     console.log('file',Object.keys(file))
                    //     setGallery(oldArray => [...oldArray, file]);
                    // });
                    for(let itemRef of res.items){
                        const file = await buildItem(itemRef);
                        console.log('file',Object.keys(file),file)
                        setGallery(oldArray => [...oldArray, file]);
                    }
                }).catch((error) => {
                    console.log(error);
                    
                    setLoading(false);
                });
            for(let media of medias){
                const res = await mediaObtener({media})
                console.log(res,JSON.stringify(res))
                const type = format.MapContentType(res.data.type)
                debugger
                const url = URL.createObjectURL(res.data);
                const title = `file.${format.MimeToExtension(res.data.type)}`
                const itm = {url, type, altTag: title, title, hiddenDelete:true}
                setGallery(oldArray => [...oldArray, itm]);
                debugger
            }
            console.log('medias',medias)
            debugger
        // });

    };

    useEffect(() => {
        getGalery();
    }, []);

    const buildItem = (itemRef: StorageReference) => {
        return new Promise < any > (async (resolve, reject) => {

            let type: any;
            let url: any;

            // Get metadata properties
            await getMetadata(itemRef)
                .then((metadata) => {
                    type = metadata.contentType?.includes('video') ? 'video' : 'photo';
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });

            await getDownloadURL(itemRef)
                .then((downloadURL) => {
                    url = downloadURL;
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });

            const newItem: GalleryItem = {
                url,
                type,
                altTag: itemRef.name,
                title: itemRef.name
            };

            resolve(newItem);
        });
    };

    const openImageModal = (url: string) => {
        modalRef.current.style.display = "block";
        modalImageRef.current.style.backgroundImage = `url(${url})`;

    }

    const closeModal = () => {
        modalRef.current.style.display = "none";
        modalImageRef.current.style.backgroundImage = 'none';
    };

    const handleDelete = (resource: GalleryItem) => {

        Swal.fire({
            title: languaje === 'ES' ? `¿Está seguro de eliminar esté archivo` : `Are you sure that you want delete this file?`,
            text: languaje === 'ES' ? '¡No podrás revertir esto!' : "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: languaje === 'ES' ? '¡Sí, bórralo!' : 'Yes, delete it!',
            cancelButtonText: languaje === 'ES' ? 'Cancelar' : 'Cancel'
        }).then(async (result) => {
            if (result.isConfirmed) {

                const storageRef = ref(storage, `mascotas/${id}/${resource.title}`);
                deleteObject(storageRef).then(() => {
                    Swal.fire(
                        languaje === 'ES' ? 'Eliminado' : 'Deleted!',
                        languaje === 'ES' ? 'Tú mascota ha sido eliminada con éxito' : 'Your pet has been deleted.',
                        'success'
                    );
                    window.location.reload();
                    //getGalery();
                }).catch((error) => {
                    console.log(error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Lo sentimos ocurrio un error...',
                        text: 'Contacta con el administrador'
                    });
                });
            }
        });


    };

    return (
        <div className='row'>
            {loading ? <div className="col-12 text-center"><IsLoading /></div> :
                <> {gallery.map((resource, i) => {
                    return (
                        <div className="col-12 col-md-12 col-xl-6 card__container" key={resource.altTag}>
                            <Card className='h-100 w-100' style={{ overflow: 'hidden' }}>
                                <Card.Body className='p-0 position-relative'>
                                    {/* <div className="row"> */}

                                    {resource.type === 'photo' ?
                                        <img src={resource.url} alt={resource.title} className='img-fluid img-gallery' style={{ width: '100%', height: '100%', objectFit: 'cover' }} onClick={() => openImageModal(resource.url)} /> :
                                        <div className="embed-responsive embed-responsive-4by3 pb-4" style={{ width: '100%', height: '100%', objectFit: 'cover' }}>
                                            <iframe className="embed-responsive-item youtube-player" src={resource.url} title={resource.title} allowFullScreen frameBorder={0} ></iframe>
                                        </div>
                                    }

                                    {
                                        canDelete && !resource.hiddenDelete &&
                                        <div className="col-12 d-flex justify-content-center align-items-center position-absolute" style={{ bottom: 0 }}>
                                            <button type='button' className="btn-sm btn-outline-danger w-50 mt-2" onClick={() => handleDelete(resource)}>Eliminar</button>
                                        </div>
                                    }
                                    {/* </div> */}
                                </Card.Body>
                            </Card>
                        </div>
                    )
                })}
                
                    <div className="modal pato" ref={modalRef}>
                        <div className="overlay"></div>
                        <span className="close" onClick={(() => closeModal())}><FontAwesomeIcon icon={faTimes as IconProp} /></span>
                        <div className="modal-image" ref={modalImageRef}></div>
                    </div>
                </>
            } </div>
    )
}

interface GalleryItem {
    url: string;
    type: 'photo' | 'video';
    altTag: string;
    title: string;
}
